import { render } from "./TagButton.vue?vue&type=template&id=cb2af640&scoped=true"
import script from "./TagButton.vue?vue&type=script&lang=js"
export * from "./TagButton.vue?vue&type=script&lang=js"

import "./TagButton.vue?vue&type=style&index=0&id=cb2af640&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb2af640"]])

export default __exports__